import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { path: '/overall' },
  },
  {
    path: '/overall',
    component: () => import('../views/sascreen/overall/index.vue')
  },
  {
    path: '/compliance',
    component: () => import('../views/sascreen/compliance/index.vue')
  },
  {
    path: '/dc',
    component: () => import('../views/sascreen/dc/index.vue')
  },
  {
    path: '/monitoring',
    component: () => import('../views/sascreen/monitoring/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
